import React from "react";
import Footer from "./Footer";
import "./Home.css";
import { Component } from "react";
import ApiService from "../../_services/ApiService";
import Config from './../../_config/config';

import Card from "react-bootstrap/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import download from "./images/downloads.png";
import download2 from "./images/downloads2.png";
import Container from "react-bootstrap/Container";
import Loader from "./../../_components/loader/loader";
import tile from "./images/tile.svg";
import list from "./images/list.svg";
import Utils from "../../_helpers/utils";

class MentorRepository extends Component{

    constructor(props) {
        super(props);
        this.state = {
          Resources: [],
          loading: true,
          isMobile: true,
          resourceLength:0,
          view: "grid",
        };
    }

    componentDidMount(){

      //
      if(Utils.isMobileDevice()) {
      this.setState({
        view: "grid",
        isMobile:true
      });  
    }else {
      this.setState({
        view: "list",
        isMobile:false
      });
    }
        // getResource List
        var postJsonData = {
            "resourceTypeIds": [6, 30]
        };
        ApiService.getTaskResources(postJsonData)
        .then((res) => {
          // SuccessCB
          const resource = res.data;
          const resourceLength = Object.keys(resource).length;
          if(resourceLength>0){

          const filterPDFObjects = (resource) => {
            return resource.filter((item) => item.url.endsWith('.pdf'));
          };
          const url = filterPDFObjects(resource);
          this.setState({Resources:url,loading:false,resourceLength:resourceLength});
        }else{
          this.setState({loading:false});
        }
            
        })
        .catch(error => {
          // ErrorCB
          console.log("Resource list Error: " + Config.CONNECTION_ERROR);
        });
    }
    changeView(view) {
      this.setState({view: view});    
    }
    openUrl(url) {
      window.open(url, "_blank");
    }

    renderRepo = () => {

              const icon = download;
              return(
                this.state.resourceLength>0 ?(<div class ="homeContainer repo_body">
                    {this.state.Resources.map((item, index) => (
                      <Card
                      key={index} >
                      <Card.Body>
                        <div className="cardbody head align-center">
                        <span className="sno">{index + 1}</span>
                            <span className="resource_name">{item.name}</span>
                            <span className="resource_type_name">
                              {item.typeName}
                            </span>
                            <span className="resource_date">{item.creationDate}</span>
                          <span className="resource_action"> <a className="" onClick={() => this.openUrl(item.url)}>
                            <img src={icon} alt={item.name} /></a></span>
                        </div>
                      </Card.Body>
                    </Card>
                    ))}
                    <Footer />
              </div>):( <Card>
                          <Card.Body>
                            <div className="cardbody">
                              <h4 className="head">No Resources Found!</h4>
                            </div>
                          </Card.Body>
                        </Card>
                      )
              );
    }
  
    //render Mobile 
    renderMobile = () => {
      return (
        this.state.resourceLength > 0 ? (<div class ="homeContainer repo_body">
        {  this.state.Resources.map((item, index) => {
            const icon = download;
            return (
              <div key={index} class="repo_list">
                <div className="row">
                  <div className="col-12">
                    <div className="course_box">
                      <div className="card">
                        
                        <div className="head row" >
                          <div className="col-8">
                          <p className="title"><strong>{item.name}</strong></p>
                          <p className="title"><strong>{item.typeName}</strong></p>
                          <p className="light_blue">Date : {item.creationDate}</p>
                        </div>
                        <div className="col-4">
                              <a className="" onClick={() => this.openUrl(item.url)}>
                                  <img src={icon} alt={item.name} />
                              </a>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }) }
          <Footer />
          </div>
        ) : (
          <div>
            <div className="cardbody">
              <h4 className="head">No Resources Found!</h4>
            </div>
          </div>
        )
      );
    }
    
    
    render(){
      const { loading } = this.state;
      const icon2 = download2;
      return (
        //header start
        <div className="Message repo-container">
        {loading ? (
          <Loader />
        ) : (
        <Container fluid>
            <div className="module-header">
                    <div
                      className={`module-header-inner cool-green-card`} >
                      <div className="back">
                        <FontAwesomeIcon
                          icon={faArrowLeft}
                          onClick={this.props.history.goBack}
                        />
                      </div>
                      <img src={icon2} alt='' />
                    </div>
                    <div className="arrow-set">
                      {
                    this.state.isMobile ?
                    <div className="row">  
                      <div className="col-10">
                        <h3>Repositories</h3>
                      </div>
                      <div className="col-2">
                        {this.state.view === 'list'? <img alt="list" src={tile} className="border"  onClick={() => this.changeView('grid')} />: <img alt="grid" src={list} className="border"  onClick={() => this.changeView('list')}/> }
                      </div>
                    </div>
                    :
                    <h4>Repositories</h4>
                  }
                    </div>
            </div>
        
        <div className="download_list card_list">
          <Card>
            <Card.Body>
              <div className="repository_header cardbody head align-center">
                <span className="sno">#</span>
                <span className="resource_name">Name</span>
                <span className="resource_type_name">Description</span>
                <span className="resource_date">Date</span>
                <span className="resource_action">Action</span>
              </div>
            </Card.Body>
          </Card>
          
              {this.state.view === 'grid'?this.renderMobile():this.renderRepo()}

        </div>
        </Container>
        )}
        </div>
      );
    }
  }
  
  export default MentorRepository ;
  